import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.3em] text-gb-silver ${className}`}>
    <span className="mr-3 inline-block h-px w-8 align-middle bg-gb-silver/60" aria-hidden="true" />
    {children}
  </p>
);
